import React from "react";

export default function Chip({
  category,
  subCategories,
  selectedCategory,
  setSelectedCategory,
  _key,
  organizer,
  selectedOrganizer,
  setSelectedOrganizer,
}) {
  // console.log("checking category ", category);
  // console.log("checking category ", subCategories);
  let _cat = category.split("|");
  let categoryName = _cat[0];
  let backgroundColor = _cat[1];
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        marginBottom: 5,
      }}
      key={_key}
    >
      <div
        onClick={() => {
          setSelectedCategory(categoryName);
          setSelectedOrganizer(organizer);
        }}
        style={{ cursor: "pointer" }}
      >
        <p
          className="p-nunito"
          style={{
            marginBottom: 0,
            padding: "4px 12px",
            backgroundColor,
            marginRight: 5,
            color: "white",
          }}
        >
          {categoryName}
        </p>
      </div>
      {categoryName === selectedCategory && selectedOrganizer === organizer && (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            // transition: 'width 5s',
            // width: categoryName === selectedCategory ? 'auto' : 0,
            // overflow: "hidden"
          }}
        >
          {subCategories.map((value) => {
            let _sub = value.split("|");
            let subCategory = _sub[0];
            let backgroundColor = _sub[1];
            return (
              <p
                className="p-nunito"
                style={{
                  marginBottom: 0,
                  padding: "4px 12px",
                  backgroundColor,
                  marginRight: 5,
                }}
              >
                {subCategory}
              </p>
            );
          })}
        </div>
      )}
    </div>
  );
}
